export abstract class BaseEvent {
  public static getEventType() {
    return this.name;
  }
}

export class ProgressUpdateEvent extends BaseEvent {
  constructor(
    public AggregationId: string,
    public CurrentScore: number,
    public KeyId: string,
    public ContentType: string,
    public MessageType: number
  ) {
    super();
  }
}

export interface SignalRData {
  CorrelationId?: string;
  AggregationId?: string;
  CurrentScore?: number;
  KeyId?: string;
  ContentType?: string;
  MessageType?: number;
  [key: string]: unknown;
}

export class BalanceUpdateEvent extends BaseEvent {
  constructor(
    public Amount: number,
    public ContentType: string,
    public MessageType: number,
    public AggregationId?: string,
    public CoinId?: string,
    public AddedAmount?: number,
  ) {
    super();
  }
}
